export default "__VITE_ASSET__BlgGgBbE__"